const state = {
}

const mutations = {
}

const actions = {
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js